export default "__VITE_ASSET__CMnMueAW__"